import { useMemo, useState } from "react";
import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
  Stack,
  ModalCloseButton,
} from "@chakra-ui/react";
import Input from "components/Input/Input";
import { isEmpty, toLower } from "lodash";

import { ReactComponent as EmptyStateIcon } from "assets/svg/empty-inpl.svg";

function ListItem(props) {
  const { title, sub, current, isDisabled, onClick } = props;
  return (
    <Button
      variant="unstyled"
      d="block"
      w="100%"
      borderRadius="0"
      p="10px 20px"
      h="fit-content"
      onClick={onClick}
      _focus={{ shadow: "none" }}
      _hover={{ bg: "#EFF0F75f" }}
      sx={{
        "&:hover #listItem__title": {
          color: current ? "#03A438" : "black",
        },
        "&:hover #listItem__subtitle": {
          color: "blackAlpha.700",
        },
      }}
      isDisabled={isDisabled}
    >
      <Stack alignItems="flex-start">
        <Text
          fontSzie="16px"
          color={current ? "#03A438" : "gray.500"}
          id="listItem__title"
        >
          {title}
        </Text>
        <Text
          mt="0 !important"
          fontSize="12px"
          color="#A0A3BD"
          id="listItem__subtitle"
        >
          {sub}
        </Text>
      </Stack>
    </Button>
  );
}

export default function SelectionModal(props) {
  const { isOpen, onClose, modalFor, values, onSelect } = props;

  const [searchParam, setSearchParam] = useState(null);

  const handleSelect = (value) => {
    onSelect && onSelect(value);
    onClose();
    setSearchParam(null);
  };

  const _items = useMemo(
    () => [
      { title: "Earn", sub: "Staking", value: "earn" },
      { title: "Main", sub: "Deposit & Withdraw", value: "main" },
      {
        title: "Savings",
        sub: "Coming Soon",
        value: "savings",
        disabled: true,
      },
      {
        title: "De-fi Savings",
        sub: "Coming Soon",
        value: "de-fi",
        disabled: true,
      },
    ],
    []
  );

  const items = useMemo(
    () =>
      _items.filter(
        (item) => item.value !== values?.from && item.value !== values?.to
      ),
    [values, _items]
  );

  const searchResults = useMemo(
    () =>
      items.filter(
        (item) =>
          toLower(item.value).includes(searchParam) ||
          toLower(item.sub).includes(searchParam) ||
          toLower(item.title).includes(searchParam)
      ),
    [searchParam, items]
  );

  const list = useMemo(
    () => (searchParam?.length > 0 ? searchResults : items),
    [searchParam, items, searchResults]
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        onClose();
        setSearchParam(null);
      }}
      isCentered
      autoFocus
      returnFocusOnClose
      motionPreset="slideInBottom"
    >
      <ModalOverlay backdropFilter="blur(2px) hue-rotate(10deg)" />
      <ModalContent
        // maxW={300}
        // bg="#03A438"
        // isCentered
        // fontFamily="var(--poppins)"
        overflow="hidden"
        borderRadius="16px"
      >
        <ModalCloseButton
          size="sm"
          top="16px"
          right="20px"
          _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
        />
        <ModalBody p="0">
          <Box p="20px">
            <ModalHeader
              p="0"
              fontSize="12px"
              color="#A0A3BD"
              textTransform="uppercase"
              mb="12px"
            >
              {modalFor}
            </ModalHeader>

            <Input
              minH="48px"
              borderRadius="12px"
              placeholder="Search wallets"
              value={searchParam ?? ""}
              onChange={(e) => setSearchParam(e.target.value)}
            />
          </Box>

          <Box h="200px" overflowY="scroll">
            {list?.map((item) => (
              <ListItem
                title={item.title}
                sub={item.sub}
                onClick={() => handleSelect(item.value)}
                current={item.value === values[modalFor]}
                isDisabled={item?.disabled}
              />
            ))}

            {searchParam && isEmpty(searchResults) && (
              <VStack py="20px">
                <Box boxSize="56px" as={EmptyStateIcon} />
                <Text color="gray.400">No results</Text>
              </VStack>
            )}
          </Box>
        </ModalBody>

        {/* <ModalFooter as={HStack} justify="flex-end">
          <Button
            onClick={onClose}
            minW="60px"
            size="sm"
            color="white"
            variant="ghost"
          >
            Close
          </Button>
        </ModalFooter> */}
      </ModalContent>
    </Modal>
  );
}
